import type { AppVueRouter } from '@modules/core/services/router/types';
import type { TranslationKeysMapper } from '@modules/i18n/types';
import type { AppMenu } from '@modules/sidebar/utils';
import { AffiliateProgramCommissionsEditModule } from '@modules/affiliate-program-commissions/submodules/edit/AffiliateProgramCommissionsEditModule';
import { AppModule } from '@modules/core/plugins/AppModule';
import { useI18n } from '@modules/i18n/composables';
import {
  ADMIN_PARTNERSHIP_MENU_ITEM,
  TRANSLATION_GROUP_SIDEBAR,
} from '@modules/sidebar/constants';

import {
  AFFILIATE_PROGRAM_COMMISSIONS_LIST_ROUTE_NAME,
  AFFILIATE_PROGRAM_COMMISSIONS_PERMISSIONS,
  AFFILIATE_PROGRAM_COMMISSIONS_ROUTE_NAME,
  TRANSLATION_GROUP_AFFILIATE_PROGRAM_COMMISSIONS,
} from './constants';
import { getTranslationKeys } from './translations';

export class AffiliateProgramCommissionsModule extends AppModule {
  protected submodules = [
    new AffiliateProgramCommissionsEditModule(),
  ];

  addRoutes(router: AppVueRouter): void {
    router.addAdminRoute({
      name: AFFILIATE_PROGRAM_COMMISSIONS_ROUTE_NAME,
      path: 'commissions',
      permission: AFFILIATE_PROGRAM_COMMISSIONS_PERMISSIONS.SHOW,
      component: () => import('@modules/core/components/SimpleChildRoutePage/SimpleChildRoutePage.vue'),
      keepAliveInclude: 'AffiliateProgramCommissionsListPage',
    });

    router.addChildRoute(AFFILIATE_PROGRAM_COMMISSIONS_ROUTE_NAME, {
      name: AFFILIATE_PROGRAM_COMMISSIONS_LIST_ROUTE_NAME,
      path: '',
      permission: AFFILIATE_PROGRAM_COMMISSIONS_PERMISSIONS.SHOW,
      component: () => import('./pages/AffiliateProgramCommissionsListPage/AffiliateProgramCommissionsListPage.vue'),
    });
  }

  addMenu(menu: AppMenu): void {
    const { getTPath } = useI18n();

    menu.addChildAdminMenuItem(ADMIN_PARTNERSHIP_MENU_ITEM, {
      caption: getTPath(TRANSLATION_GROUP_SIDEBAR, 'ADMIN_PARTNERSHIP_CONDITIONS'),
      to: {
        name: AFFILIATE_PROGRAM_COMMISSIONS_LIST_ROUTE_NAME,
      },
      permission: AFFILIATE_PROGRAM_COMMISSIONS_PERMISSIONS.SHOW,
      id: AFFILIATE_PROGRAM_COMMISSIONS_LIST_ROUTE_NAME,
      order: 30,
    });
  }

  addTranslationKeys(mapper: TranslationKeysMapper): void {
    mapper.addTranslationsMap(TRANSLATION_GROUP_AFFILIATE_PROGRAM_COMMISSIONS, getTranslationKeys);
  }
}
